// extracted by mini-css-extract-plugin
export default {"footer":"ZepirHkak4Ptw6LGSA1H","align-left":"Ts8UuXiIfyI8WlkNsQTA","align-right":"PhlKCtV3PGvQjAdbm0uy","layout-col":"_bwk2OcxHMs8RBUEo8HQ","pulse":"eAKhp3V5x5FxeKVdSSRY"};